import loadableWrapper from '../../utils/loadable';

const ProofOfReviewsRoutes = [{
  path: `/proof-of-reviews`,
  exact: true,
  component: loadableWrapper(() => import('./components/List')),
  layoutConfig: {
    isUsedAppShell: true,
    title: 'Proof of reviews',
    routes: [
      {
        breadcrumbName: 'Proof of reviews',
      },
    ],
  },
}];

export default ProofOfReviewsRoutes;
